var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg3 = function Svg3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "3_svg__a",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogdXJsKCNsaW5lYXItZ3JhZGllbnQpOwogICAgICB9CiAgICA8L3N0eWxlPgogICAgPGxpbmVhckdyYWRpZW50IGlkPSJsaW5lYXItZ3JhZGllbnQiIHkxPSI0NC44NjMiIHgyPSI0OCIgeTI9IjMuMTM3IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgIDxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iI2ZmOWQwMCIvPgogICAgICA8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNmZmNkMDAiLz4KICAgIDwvbGluZWFyR3JhZGllbnQ+CiAgPC9kZWZzPgogIDxyZWN0IGNsYXNzPSJjbHMtMSIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4Ii8+Cjwvc3ZnPgo=",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    preserveAspectRatio: "none",
    result: "image"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in",
    result: "composite"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "SourceGraphic",
    result: "blend"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.176v34.077l23.8 11.762L48 36.253V-.013H0v2.189Z",
    "data-name": "\\u5F62\\u72B6 26 \\u62F7\\u8D1D 2",
    style: {
      fill: "#f9130b",
      fillRule: "evenodd",
      filter: "url(#3_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": 3,
    style: {
      fontSize: 35,
      fill: "#fff",
      fontFamily: "&quot"
    },
    transform: "matrix(.96 0 0 .98 13.533 33.836)"
  }, "3"));
};
export default Svg3;